import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DashboardBaseComponent } from '../dashboard-base/dashboard-base.component';

@Component({
  selector: 'wsg-todo',
  templateUrl: './todo.component.html',
  styleUrls: ['./todo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TodoComponent extends DashboardBaseComponent {
  title = 'To-dos';
}
